module.exports = __webpack_public_path__ + "static/media/500.a0320da1.svg";